import { Dispatch } from "redux";
import { connect } from "react-redux";
import { reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";
import { injectIntl } from "react-intl";

import { Login as LoginComponent, LoginStateProps, LoginDispatchProps } from "./presenter";
import { LoginDetails, AuthState } from "../../models";
import { messages } from "../../messages";
import { getIsAuthenticated } from "../../selectors";
import { ApiAction } from "@api/actions";
import { Api } from "@api/index";
import { validate, ValidationRules } from "@validation/index";
import { compose } from "@util/compose";

// The validation rules.
const rules: ValidationRules = {
    email: {
        label: messages.authLoginEmail,
        rules: [
            { type: "required" },
            { type: "email" },
        ],
    },
    password: {
        label: messages.authLoginPassword,
        rules: [
            { type: "required" },
        ],
    },
};

// Map the auth state to the component.
function mapStateToProps(state: AuthState, ownProps: {}) {
    return {
        authenticated: getIsAuthenticated(state),
    } as LoginStateProps;
}

// Map the request login action to the component
function mapDispatchToProps(dispatch: Dispatch<ApiAction>) {
    return {
        login: (credentials: LoginDetails) => {
            const action = Api.login(credentials);
            dispatch(action);
            return action;
        },
    } as LoginDispatchProps;
}

// Wrap the component in i18n, the form and connect to Redux.
const Login = compose<LoginStateProps & LoginDispatchProps, {}>(
    injectIntl,
    reduxForm({
        form: "login",
        validate: validate(rules),
        destroyOnUnmount: false,
    }),
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
)(LoginComponent);

export { Login };
